import React, { FC } from 'react';
import { Route, Router, Switch, useHistory } from 'react-router';

import { ComponentDrilldownPage } from '../../components/drilldown/ComponentDrilldownPage';
import { IssueTypeDrilldownPage } from '../../components/drilldown/IssueTypeDrilldownPage';
import { UrlDrilldownPage } from '../../components/drilldown/UrlDrilldownPage';
import { UrlsStatusDrilldownPage } from '../../components/drilldown/UrlsStatusDrilldownPage';
import { TabsViews } from '../../types/TabsViews';

import { ScanAnalysisPageWithTabs } from './ScanAnalysisPage';

const ScanRouter: FC = () => {
	const history = useHistory();
	const basePath = '/properties/:propertyId/scans/:scanId';
	return (
		<Router history={history}>
			<Switch>
				<Route
					exact
					path={`${basePath}/overview`}
					render={() => <ScanAnalysisPageWithTabs view={TabsViews.OVERVIEW} />}
				/>
				<Route
					exact
					path={`${basePath}/pages`}
					render={() => <ScanAnalysisPageWithTabs view={TabsViews.PAGES} />}
				/>
				<Route
					exact
					path={`${basePath}/issue-types`}
					render={() => <ScanAnalysisPageWithTabs view={TabsViews.ISSUE_TYPES} />}
				/>
				<Route
					exact
					path={`${basePath}/all-issues`}
					render={() => <ScanAnalysisPageWithTabs view={TabsViews.BREAKDOWN} />}
				/>
				<Route
					exact
					path={`${basePath}/components`}
					render={() => <ScanAnalysisPageWithTabs view={TabsViews.COMPONENTS} />}
				/>
				<Route
					exact
					path={`${basePath}`}
					render={() => <ScanAnalysisPageWithTabs view={TabsViews.OVERVIEW} />}
				/>
				<Route exact path={`${basePath}/overview`} component={ScanAnalysisPageWithTabs} />
				<Route
					exact
					path={`${basePath}/components/:componentId`}
					render={() => <ComponentDrilldownPage />}
				/>
				<Route exact path={`${basePath}/urls-status`} render={() => <UrlsStatusDrilldownPage />} />
				<Route exact path={`${basePath}/page`} render={() => <UrlDrilldownPage />} />
				<Route
					exact
					path={`${basePath}/issue-types/:issueType`}
					render={() => <IssueTypeDrilldownPage />}
				/>
				<Route render={() => <ScanAnalysisPageWithTabs view={TabsViews.OVERVIEW} />} />
			</Switch>
		</Router>
	);
};

export { ScanRouter };
